import { REPORTS } from '@/constants'

export interface StoredReportingWorkspace {
    workspaceId: number | null
}

function getStorage(): Storage | null {
    if (typeof localStorage === 'undefined') {
        return null
    }

    return localStorage
}

export function loadReportingWorkspace(storageKey: string): StoredReportingWorkspace | null {
    const storage = getStorage()

    if (!storage) {
        return null
    }

    const rawValue = storage.getItem(storageKey)

    if (!rawValue) {
        return null
    }

    try {
        return JSON.parse(rawValue) as StoredReportingWorkspace
    } catch {
        return null
    }
}

export function persistReportingWorkspace(storageKey: string, workspaceId: number | null): void {
    const storage = getStorage()

    if (!storage) {
        return
    }

    if (workspaceId == null) {
        storage.removeItem(storageKey)
        return
    }

    storage.setItem(
        storageKey,
        JSON.stringify({
            workspaceId
        })
    )
}

export function clearReportingWorkspace(storageKey: string): void {
    const storage = getStorage()

    if (!storage) {
        return
    }

    storage.removeItem(storageKey)
}

export function loadOperatorReportingWorkspace(): StoredReportingWorkspace | null {
    return loadReportingWorkspace(REPORTS.WORKSPACE_STORAGE_KEYS.OPERATOR)
}

export function loadPaperReportingWorkspace(): StoredReportingWorkspace | null {
    return loadReportingWorkspace(REPORTS.WORKSPACE_STORAGE_KEYS.PAPER_REPORTING)
}
